<template>
    <div>
        <div>
            <span
                v-if="showSearch"
                class="selectSearchable__wrapper input__wrapper"
                role="search"
                :aria-labelledby="searchInputLabelledBy">
                <svg
                    class="text-color--gray-blue input__icon"
                    height="16"
                    width="16"
                    aria-hidden="true">
                    <use href="#iconMagnifyingGlassRegular" />
                </svg>
                <input
                    :id="searchId"
                    v-model="searchInput"
                    type="search"
                    :name="searchName"
                    :disabled="disabled"
                    :placeholder="searchPlaceholder"
                    :aria-labelledby="searchInputLabelledBy"
                    class="tagged-input__realinput"
                    autocomplete="off"
                    @keydown="scrollToResult"
                    @keydown.tab.prevent="tabToResult" />
            </span>
            <div
                :id="id"
                ref="scrollbox"
                :style="{ height: `${ optionsHeight }px` }"
                class="selectSearchable__scrollbox checkboxGroup scrollBox"
                :disabled="disabled"
                role="listbox"
                tabindex="0">
                <label
                    v-for="option in optionsData"
                    :id="`${ optionIdPrefix }label_${ option.value }`"
                    :key="option.value"
                    class="sidebarFilter__wrapper sidebarFilter__wrapper--checkBox sidebarFilter__checkBoxLabel"
                    :for="optionIdPrefix + option.value"
                    role="option"
                    :aria-selected="option[optionCheckedProp]"
                    :tabindex="option[optionCheckedProp] ? 0 : -1">
                    <span class="sidebarFilter__searchableCheckBox">
                        <input
                            :id="optionIdPrefix + option.value"
                            v-model="option[optionCheckedProp]"
                            class="customCheckboxInput"
                            type="checkbox"
                            :name="optionIdPrefix + option.value"
                            :value="option.value"
                            :disabled="disabled" />
                        <span class="customCheckbox"></span>
                        {{ option.name }}
                    </span>
                </label>
            </div>
        </div>
        <div v-if="showTags">
            <div
                v-for="selectedOption in selectedOptions"
                :key="selectedOption.value"
                class="filterTag"
                tabindex="0"
                role="button"
                @click="removeSelectedOption(selectedOption)">
                <span
                    class="filterTag__text"
                    v-text="selectedOption.name"></span>
                <span class="filterTag__icon">&times;</span>
            </div>
        </div>
    </div>
</template>
<script>
    const EVENT_CHANGE = 'change';
    const CHECKED = 'checked';
    const LABEL = 'label';
    const FLAG_REGEX = 'g';
    const HTML_EVENTS = 'HTMLEvents';
    const SELECT = 'select';

    export default {
        model: {
            prop: CHECKED,
            event: EVENT_CHANGE,
        },
        props: {
            id: { type: String, required: true },
            options: { type: Array, required: true },
            name: { type: String, required: true },
            optionIdPrefix: { type: String, default: 'option_' },
            disabled: { type: Boolean, default: false },
            label: { type: String, default: null },
            searchId: { type: String, default: null },
            searchName: { type: String, default: null },
            searchPlaceholder: { type: String, default: null },
            searchValue: { type: String, default: '' },
            showSearch: { type: Boolean, default: true },
            filter: { type: Function, default: null },
            showTags: { type: Boolean, default: true },
            optionsHeight: { type: Number, default: 150 },
            optionCheckedProp: { type: String, default: 'checked' },
            searchInputLabelledBy: { type: String, default: null },
        },
        data() {
            return {
                searchInput: this.searchValue,
                optionsData: this.options,
            };
        },
        computed: {
            selectedOptions() {
                return this.optionsData.filter(option => option[this.optionCheckedProp]);
            },
        },
        watch: {
            selectedOptions(selectedOptions) {
                this.$emit(SELECT, selectedOptions);
            },
            options(options) {
                this.optionsData = options;
            },
            searchInput(newValue) {
                if (newValue === '') {
                    this.$refs.scrollbox.scrollTop = 0;
                }
            },
        },
        methods: {
            scrollToResult(event) {

                const re = new RegExp(`^${ event.target.value.toLowerCase() }.*?`, FLAG_REGEX);

                const scrollToElement = this.optionsData.find(option => {

                    return option.name.toLowerCase().match(re) ?? null;
                });

                if (scrollToElement) {
                    const scrollToDomElement = document.getElementById(this.optionIdPrefix + scrollToElement.value);
                    const currentPos = scrollToDomElement.offsetTop;
                    const itemHeight = scrollToDomElement.clientHeight;
                    this.$refs.scrollbox.scrollTop = currentPos - itemHeight;
                }
            },
            removeSelectedOption(selectedOption) {
                const toBeUnselected = this.optionsData.find(option => option.value === selectedOption.value);
                toBeUnselected[this.optionCheckedProp] = false;
                this.emitChangeEvent();
            },
            emitChangeEvent() {
                const changeEvent = document.createEvent(HTML_EVENTS);
                changeEvent.initEvent(EVENT_CHANGE, true, true);
                this.$el.dispatchEvent(changeEvent);
            },
            tabToResult() {
                const scrollBox = document.getElementById(this.id);
                const listOfOptions = Array.from(scrollBox.querySelectorAll(LABEL));
                const scrollBoxOffsetTop = scrollBox.getBoundingClientRect().top;
                listOfOptions.find(option => option.getBoundingClientRect().top > scrollBoxOffsetTop)?.focus();
            },
        },
    };
</script>
